import React from 'react';

import PropTypes from 'prop-types';

import { Script } from '@techstyle/react-marketing';

import generateCdnImageUrl from '../../../src/utils/generateCdnImageUrl';

function makeSchema(product) {
  return {
    '@context': 'http://schema.org',
    '@type': 'Product',
    title: product.label,
    name: product.label,
    description: product.long_description,
    image: generateCdnImageUrl({
      product,
      angle: 'LAYDOWN',
      imageSize: 8,
    }),
    sku: product.master_product_id,
  };
}

export default function ProductDetailPageSchema({ product }) {
  return (
    <Script
      globalScriptKey={`productJSON-${product.master_product_id}`}
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(makeSchema(product)) }}
    />
  );
}

ProductDetailPageSchema.propTypes = {
  product: {
    master_product_id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    long_description: PropTypes.string.isRequired,
  },
};
